import { FormikValues } from 'formik'

import { AdGroupCreateInput } from '../../../../__generated__/graphql'
import { AdgroupCreateFormValues } from '../../../adgroup/create/buildAdgroupCreateInitialValues'
import { toAdGroupCreateInput } from '../../../adgroup/create/toAdGroupCreateInput'
import prepareFormValues from '../../../../utils/prepareFormValues'

export type CampaignCreateAdgroupDraft = AdgroupCreateFormValues & {
  draftId: string
}

const createDraftId = (): string =>
  globalThis.crypto?.randomUUID?.() ?? `draft-${Date.now()}-${Math.random().toString(36).slice(2)}`

export const createAdgroupDraft = (
  adgroup: Omit<CampaignCreateAdgroupDraft, 'draftId'>
): CampaignCreateAdgroupDraft => ({
  ...adgroup,
  draftId: createDraftId(),
})

export const stripAdgroupDraftId = ({ draftId, ...rest }: CampaignCreateAdgroupDraft): AdgroupCreateFormValues => {
  void draftId
  return rest
}

export const adgroupDraftToCreateInput = (
  draft: CampaignCreateAdgroupDraft,
  campaignId: string | number
): AdGroupCreateInput => toAdGroupCreateInput(prepareFormValues(stripAdgroupDraftId(draft)), campaignId)

export const getCampaignCreateAdgroupDrafts = (values: FormikValues): CampaignCreateAdgroupDraft[] =>
  (values.adgroups as CampaignCreateAdgroupDraft[] | undefined) ?? []
